import axios from 'axios';
import { DAPI_ROOT_URL } from '../globalConfiguration';
import { isNumber } from 'lodash-es';

export async function checkLeadboxSpamFilter(fields, country, nature, score) {
  const res = await axios.post(DAPI_ROOT_URL + '/spam/verify', {
    formState: {
      ...fields,
      sys_nature: nature,
      ...(isNumber(score) ? { sys_recaptcha_score: score } : {}),
    },
    country,
  });

  return res.data?.data?.requires_verification;
}
